import { create } from "lodash";
import { fetchError, fetchStart, fetchSuccess } from "../../redux/actions";
import {
  addBlog,
  getAllPoints,
  getAllPointsBank,
  getSinglePrize,
  getSinglePurchase,
  removeBlog,
  removePrize,
  setAllNews,
  setAllNotifcations,
  setAllPrizes,
  setBlogCurrentPage,
  setBlogTotalPages,
  setNotificationsCurrentPage,
  setNotificationsTotalPages,
  setPointsBankCurrentPage,
  setPointsBankTotalPages,
  setPointsCurrentPage,
  setPointsTotalPages,
  setPrizesCurrentPage,
  setPrizesTotalPages,
  setPurchaseList,
  setPurchasesCurrentPage,
  setPurchasesTotalPages,
} from "../../redux/actions/News";

import axios from "../auth/jwt/config";

const NewsRequests = {
  getAllBlogs: (page) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(`/blog/getall?page=${page}&limit=5`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setAllNews(data.blogs.docs));
            dispatch(setBlogCurrentPage(data.blogs.page));
            dispatch(setBlogTotalPages(data.blogs.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  addSingleBlog: (blog) => {
    return (dispatch) => {
      try {
        axios
          .post(`/blog/create`, blog)
          .then(({ data }) => {
            dispatch(fetchSuccess("با موفقیت اضافه شد"));
            dispatch(addBlog(data.blog));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  removeSingleBlog: (id) => {
    return (dispatch) => {
      try {
        axios
          .delete(`/blog/delete/${id}`)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت حذف شد"));
            dispatch(removeBlog(id));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  updateSingleBlog: (id, data) => {
    return (dispatch) => {
      try {
        axios
          .patch(`/blog/update/${id}`, data)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت به روز رسانی شد"));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getAllPrizes: (page, searchStr) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(
            `/pointshop/item/getall?page=${page}&limit=20&searchString=${searchStr ||
              ""}`
          )
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setAllPrizes(data.docs));
            dispatch(setPrizesCurrentPage(data.page));
            dispatch(setPrizesTotalPages(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getSinglePrize: (id) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(`/pointshop/item/getsingle/${id}`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(getSinglePrize(data));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  updatePirze: (id, data) => {
    return (dispatch) => {
      try {
        axios
          .post(`/pointshop/item/update/${id}`, data)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت به روز رسانی شد"));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  addPrize: (prize) => {
    return (dispatch) => {
      try {
        axios
          .post(`/pointshop/item/create`, prize)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت اضافه شد"));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  adjustPrizeInventory: (id, operation, data) => {
    return (dispatch) => {
      dispatch(fetchStart());

      return axios
        .post(`/pointshop/item/inventory/${operation}/${id}`, data)
        .then(({ data: updatedPrize }) => {
          dispatch(fetchSuccess("موجودی با موفقیت به‌روزرسانی شد"));
          return updatedPrize;
        })
        .catch((error) => {
          const message = error.response
            ? error.response.data.msgFa || error.response.data.msg
            : error.message;
          dispatch(fetchError(message));
          throw error;
        });
    };
  },
  getPrizeInventoryLogs: (id, page = 1, limit = 10, purchaseSource = "All") => {
    return (dispatch) => {
      dispatch(fetchStart());

      return axios
        .get(
          `/pointshop/item/inventory/loglist/${id}?page=${page}&limit=${limit}&purchaseSource=${purchaseSource}`
        )
        .then(({ data }) => {
          dispatch(fetchSuccess());
          return data;
        })
        .catch((error) => {
          const message = error.response
            ? error.response.data.msgFa || error.response.data.msg
            : error.message;
          dispatch(fetchError(message));
          throw error;
        });
    };
  },
  removeSinglePrize: (id) => {
    return (dispatch) => {
      try {
        axios
          .delete(`/pointshop/item/remove/${id}`)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت حذف شد"));
            dispatch(removePrize(id));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getSuggestedIndex: async () => {
    let index = 0;
    try {
      const response = await axios.get(`/blog/suggestedIndex`);
      index = response.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.msgFa);
      } else {
        console.log(error.message);
      }
    }
    return index;
  },
  getAllNotifications: (page) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(`/notification/getall?page=${page}&limit=20`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setAllNotifcations(data.docs));
            dispatch(setNotificationsCurrentPage(data.page));
            dispatch(setNotificationsTotalPages(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  addNotificatoin: (notification) => {
    return (dispatch) => {
      try {
        axios
          .post(`/notification/create`, notification)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت اضافه شد"));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getAllPoints: (page, searchStr) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(
            `/point/admin/getall?page=${page}&limit=20&searchString=${searchStr}`
          )
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(getAllPoints(data.docs));
            dispatch(setPointsCurrentPage(data.page));
            dispatch(setPointsTotalPages(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  fetchAllPointsBank: (page, searchStr) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(
            `/pointbank/getall?page=${page}&limit=20&searchString=${searchStr}`
          )
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(getAllPointsBank(data.docs));
            dispatch(setPointsBankCurrentPage(data.page));
            dispatch(setPointsBankTotalPages(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  createPoint: (data) => {
    return (dispatch) => {
      try {
        axios
          .post(`/point/admin/add`, data)
          .then(() => {
            NewsRequests.getAllPoints(1, "")(dispatch);
            setTimeout(() => {
              dispatch(fetchSuccess("باموفقیت افزوده شد"));
            }, 1000);
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  addBatchPoints: (file) => {
    return async (dispatch) => {
      const formData = new FormData();
      formData.append("csvFile", file);
      try {
        axios
          .post(`/point/admin/addBatch`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(({ data }) => {
            setTimeout(() => {
              dispatch(
                fetchSuccess(`${data.addedUserCount} مورد با موفقیت اضافه شد`)
              );
            }, 500);
            NewsRequests.getAllPoints(1, "")(dispatch);
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError("مشکل در آپلود "));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getAllPurchases: (page, searchStr) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(
            `/pointshop/purchase/admin/history?page=${page}&limit=20&searchString=${searchStr ||
              ""}`
          )
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setPurchaseList(data.docs));
            dispatch(setPurchasesCurrentPage(data.page));
            dispatch(setPurchasesTotalPages(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            }
            dispatch(fetchError(error.message));
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getSinglePurchaseById: (id) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(`/pointshop/purchase/admin/history/getsingle/${id}`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(getSinglePurchase(data));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            }
            dispatch(fetchError(error.message));
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  attendPurchase: (id) => {
    return (dispatch) => {
      try {
        axios
          .get(`/pointshop/purchase/admin/attend/${id}`)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت ثبت شد"));
            NewsRequests.getSinglePurchaseById(id)(dispatch);
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            }
            dispatch(fetchError(error.message));
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  removePurchase: (id) => {
    return (dispatch) => {
      try {
        axios
          .delete(`/pointshop/purchase/admin/remove/${id}`)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت حذف شد"));
            NewsRequests.getSinglePurchaseById(id)(dispatch);
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            }
            dispatch(fetchError(error.message));
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  createPurchase: (data) => {
    return (dispatch) => {
      try {
        axios
          .post(`/pointshop/purchase/admin`, data)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت ثبت شد"));
            NewsRequests.getAllPurchases(1, "")(dispatch);
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            }
            dispatch(fetchError(error.message));
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
};

export default NewsRequests;
